import { render, staticRenderFns } from "./NewtonRingsViz.vue?vue&type=template&id=4a96a480&scoped=true"
import script from "./NewtonRingsViz.vue?vue&type=script&lang=js"
export * from "./NewtonRingsViz.vue?vue&type=script&lang=js"
import style0 from "./NewtonRingsViz.vue?vue&type=style&index=0&id=4a96a480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a96a480",
  null
  
)

export default component.exports